import { connect } from 'react-redux';
import FileMeetingPlanUpload from './fileMeetingPlanUpload';
import { bindActionCreators } from 'redux';
import {filePlanUploadListing} from "../../../services/redux/brandActivtion/sitesListing/action";

const mapStateToProps = state => ({
    filePlanUploadData: state.baSiteListingReducer.filePlanUploadData,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    filePlanUploadListing
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(FileMeetingPlanUpload);
